import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "PricelineSidewaysPDarker__IconWrapper",
  componentId: "sc-49zth0-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 412 293",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("path", {
    fill: themeGet("palette.primary.dark")(themeProps),
    fillRule: "evenodd",
    d: "M348.674 149.182c0-16.118-6.943-32.753-24.252-45.37-16.708-12.663-42.704-18.354-70.939-18.354-38.073 0-61.748 9.775-74.426 21.212-10.974 10.34-17.309 25.28-17.309 39.646 0 43.03 46.728 61.989 94.055 61.989 39.355 0 81.015-10.672 90.855-46.002l.288-1.079c1.054-3.808 1.662-7.608 1.723-11.409zm55.32-70.465h-28.236l1.382 1.142c2.986 2.474 5.906 4.958 8.406 7.436C399.99 102.243 412 129.234 412 162.58 412 236.104 356.16 293 255.888 293 194.263 293 98.53 265.954 98.53 163.121c0-25.633 6.49-41.752 16.059-58.58l.752-1.313.764-1.317.775-1.321.392-.664.793-1.331 1.21-2.012 1.647-2.716L123.897 89H0V0h403.994z"
  }));
}
const PricelineSidewaysPDarker = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(PricelineSidewaysPDarker);
export default Memo;